module.exports = __webpack_public_path__ + "img/icon_kefu@2x.fa4920a9.png";